import { useState } from 'react'
import ReactGA from 'react-ga4'
import { useNavigate } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link'

export const DlcCharacters = () => {
     const dlcannounce = [
            {
                date: 'Releases February 20, 2025',
                characters: ' Castille et Walnut',
                game: 'Phantom Brave',
                gamelink: 'https://nisamerica.com/phantombrave-remastered/',
                inpagelink: 1,
                nswlink:
                    'https://www.nintendo.com/fr-fr/Contenu-telechargeable/Phantom-Brave-The-Lost-Hero-Bonus-Story-Parallel-Siblings-2742463.html',
                ps4link: 'https://store.playstation.com/fr-fr/product/EP1063-PPSA21030_00-PB2DLCCHARA00002',
                ps5link: 'https://store.playstation.com/fr-fr/product/EP1063-PPSA21030_00-PB2DLCCHARA00001',
            },
            {
                date: 'Releases February 27, 2025',
                characters: 'Scarlet et Germe',
                game: 'Phantom Brave',
                gamelink: 'https://nisamerica.com/phantombrave-remastered/',
                inpagelink: 3,
                nswlink:
                    'https://www.nintendo.com/fr-fr/Contenu-telechargeable/Phantom-Brave-The-Lost-Hero-Bonus-Story-Heroes-of-the-Past-2742475.html',
                ps4link: 'https://store.playstation.com/fr-fr/product/EP1063-PPSA21030_00-PB2DLCCHARA00002',
                ps5link: 'https://store.playstation.com/fr-fr/product/EP1063-PPSA21030_00-PB2DLCCHARA00002',
            },
            {
                date: 'Releases March 6, 2025',
                characters: 'Vagabond',
                game: 'BAR Stella Abyss',
                gamelink: 'https://nippon1.jp/consumer/barstellaabyss/',
                inpagelink: 5,
                nswlink:
                    'https://www.nintendo.com/fr-fr/Contenu-telechargeable/Phantom-Brave-The-Lost-Hero-Bonus-Story-The-Wandering-Pirate-2742471.html',
                ps4link: 'https://store.playstation.com/fr-fr/product/EP1063-PPSA21030_00-PB2DLCCHARA00003',
                ps5link: 'https://store.playstation.com/fr-fr/product/EP1063-PPSA21030_00-PB2DLCCHARA00003',
            },
            {
                date: 'Releases March 6, 2025',
                characters: 'Princesse',
                game: 'The Liar Princess and the Blind Prince',
                gamelink: 'https://www.nisamerica.com/the-liar-princess/',
                inpagelink: 6,
                nswlink:
                    'https://www.nintendo.com/fr-fr/Contenu-telechargeable/Phantom-Brave-The-Lost-Hero-Bonus-Story-The-Liar-and-the-Lost-2742443.html',
                ps4link: 'https://store.playstation.com/fr-fr/product/EP1063-PPSA21030_00-PB2DLCCHARA00004',
                ps5link: 'https://store.playstation.com/fr-fr/product/EP1063-PPSA21030_00-PB2DLCCHARA00004',
            },
            {
                date: 'Releases March 13, 2025',
                characters: 'Jeune fille',
                game: 'Yomawari: Night Alone',
                gamelink: 'https://nisamerica.com/yomawari/',
                inpagelink: 7,
                nswlink:
                    'https://www.nintendo.com/fr-fr/Contenu-telechargeable/Phantom-Brave-The-Lost-Hero-Bonus-Story-The-Girl-Who-Cried-Ghost-2742439.html',
                ps4link: 'https://store.playstation.com/fr-fr/product/EP1063-PPSA21030_00-PB2DLCCHARA00005',
                ps5link: 'https://store.playstation.com/fr-fr/product/EP1063-PPSA21030_00-PB2DLCCHARA00005',
            },
            {
                date: 'Releases March 13, 2025',
                characters: 'Rat fou et Cœur',
                game: 'MAD RAT DEAD',
                gamelink: 'https://www.nisamerica.com/mad-rat-dead/',
                inpagelink: 8,
                nswlink:
                    'https://www.nintendo.com/fr-fr/Contenu-telechargeable/Phantom-Brave-The-Lost-Hero-Bonus-Story-The-Rat-Who-Demons-Fear-2742451.html',
                ps4link: 'https://store.playstation.com/fr-fr/product/EP1063-PPSA21030_00-PB2DLCCHARA00006',
                ps5link: 'https://store.playstation.com/fr-fr/product/EP1063-PPSA21030_00-PB2DLCCHARA00006',
            },
        ]
        const navigate = useNavigate()
    
        const handleNavigate = (num) => {
            navigate(`/characters?tab=dlc&scrollTo=dlc-char-${num}`)
        }
        const [activeCharTab, setActiveCharTab] = useState('dlc-steamlaunch')
    return     <>
 
    <div className='lg:px-12'>
        <section className='max-w-[1000px] md:my-20 md:pb-20 mx-auto section-deco text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full px-4 md:px-0 md:w-4/5  mt-12'>
            <div className='flex justify-center mt-20'>
                <img
                    className=''
                    alt='limited edition'
                    src={`${process.env.PUBLIC_URL}/images/dlc/header-dlc-fr.webp`}
                />
            </div>{' '}
            <img
                className='mt-8'
                alt='limited edition'
                src={`${process.env.PUBLIC_URL}/images/dlc/DLC-all-fr.webp`}
            />
            <p className='mt-8'>
                Retrouvez les personnages des jeux populaires Nippon Ichi Software dans le monde de Phantom
                Brave: The Lost Hero en tant que DLC !
            </p>
            <p>
                Redécouvrez non seulement des héros du premier opus de{' '}
                <span className='hover:text-pborange cursor-pointer duration-300 underline'>
                    {' '}
                    <a target='_blank' rel='noreferrer' href='https://nisamerica.com/phantombrave-remastered/'>
                        Phantom Brave
                    </a>
                </span>{' '}
                mais aussi <span className='text-pborange'>Kotomo</span> de{' '}
                <span className='hover:text-pborange cursor-pointer duration-300 underline'>
                    <a target='_blank' rel='noreferrer' href='https://nisamerica.com/yomawari/'>
                        Yomawari: Night Alone
                    </a>
                </span>
                , ainsi que <span className='text-pborange'>Vagabond</span> de l'exclusivité japonaise
                <span className='hover:text-pborange cursor-pointer duration-300 underline'>
                    {' '}
                    <a target='_blank' rel='noreferrer' href='https://nippon1.jp/consumer/barstellaabyss/'>
                        BAR Stella Abyss{' '}
                    </a>
                </span>
                !
            </p>
            <div className='flex flex-wrap gap-1 md:gap-4 mt-20 max-w-[1000px] mx-auto justify-between items-stretch'>
                {dlcannounce.map((dlcdata, i) => (
                    <div key={i} className='w-[90%] md:w-[48%] mx-auto flex flex-col items-center h-full'>
                        <img
                            className='w-full'
                            alt='limited edition'
                            src={`${process.env.PUBLIC_URL}/images/dlc/dlc-announce-${1 + i}-fr.webp`}
                        />{' '}
                        <div className='my-8 text-center text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white'>
                            <p className=''>{dlcdata.characters}</p>{' '}
                            <a href={dlcdata.gamelink}>
                                <p className=''>
                                    ({' '}
                                    <span className='hover:text-pborange cursor-pointer duration-300 underline'>
                                        {dlcdata.game}
                                    </span>{' '}
                                    ){' '}
                                </p>
                            </a>
                            <button onClick={() => handleNavigate(dlcdata.inpagelink)}>
                                {' '}
                                <img
                                    className='max-w-[240px] my-4'
                                    alt='limited edition'
                                    src={`${process.env.PUBLIC_URL}/images/dlc/more-character-info-fr.webp`}
                                />{' '}
                            </button>
                            <div className='flex flex-row justify-around mx-auto gap-2'>
                                {dlcdata.nswlink && (
                                    <div className='mx-auto text-center'>
                                        <button>
                                            <a
                                                target='_blank'
                                                rel='noreferrer'
                                                onClick={() => {
                                                    ReactGA.event({
                                                        action: 'click',
                                                        event: 'link',
                                                        category: 'Product',
                                                        label: 'DLC - NSW - Nintendo',
                                                    })
                                                }}
                                                href={dlcdata.nswlink}
                                            >
                                                <img
                                                    className='max-w-[240px] mx-auto w-full'
                                                    alt='DLC nsw'
                                                    src={`${process.env.PUBLIC_URL}/images/products/btn_switch.png`}
                                                />{' '}
                                            </a>
                                        </button>{' '}
                                    </div>
                                )}{' '}
                                {dlcdata.ps5link && (
                                    <div className='mx-auto text-center'>
                                        <button>
                                            <a
                                                target='_blank'
                                                rel='noreferrer'
                                                onClick={() => {
                                                    ReactGA.event({
                                                        action: 'click',
                                                        event: 'link',
                                                        category: 'Product',
                                                        label: 'DLC - PS5 - PSN',
                                                    })
                                                }}
                                                href={dlcdata.ps5link}
                                            >
                                                <img
                                                    className='max-w-[240px] mx-auto w-full'
                                                    alt='DLC ps4'
                                                    src={`${process.env.PUBLIC_URL}/images/products/btn_ps5.png`}
                                                />{' '}
                                            </a>
                                        </button>
                                    </div>
                                )}
                                {dlcdata.ps4link && (
                                    <div className='mx-auto text-center'>
                                        <button>
                                            <a
                                                target='_blank'
                                                rel='noreferrer'
                                                onClick={() => {
                                                    ReactGA.event({
                                                        action: 'click',
                                                        event: 'link',
                                                        category: 'Product',
                                                        label: 'DLC - PS4 - PSN',
                                                    })
                                                }}
                                                href={dlcdata.ps4link}
                                            >
                                                <img
                                                    className='max-w-[240px] mx-auto w-full'
                                                    alt='DLC ps5'
                                                    src={`${process.env.PUBLIC_URL}/images/products/btn_ps4.png`}
                                                />{' '}
                                            </a>
                                        </button>{' '}
                                    </div>
                                )}
                            </div>
                        </div>{' '}
                    </div>
                ))}{' '}
            </div>
        </section>
    </div>
</>
}